import { render } from "./ListGenerator.vue?vue&type=template&id=12e1042c&scoped=true&ts=true"
import script from "./ListGenerator.vue?vue&type=script&lang=ts"
export * from "./ListGenerator.vue?vue&type=script&lang=ts"

import "./ListGenerator.vue?vue&type=style&index=0&id=12e1042c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e1042c"]])

export default __exports__